import React, { useEffect, useState } from "react";
import { themeBlue, themeOrange } from "../../utils/colorTheme";
import Stepper from "react-stepper-js";
import "react-stepper-js/dist/index.css";
import {
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
  Alert,
  Chip,
} from "@mui/material";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import serName from "../../assets/serviceName.webp";
import check from "../../assets/check.webp";
import { FaCalendarDays } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { IoDocumentTextSharp } from "react-icons/io5";
import { MdLock, MdClose, MdLocalOffer, MdVerifiedUser } from "react-icons/md";
import CreditCardForm from "../CreditCard/CardInput";
import GuestCheckout from "./GuestCheckout";
import { LuCalendarClock, LuCreditCard } from "react-icons/lu";
import { useNavigate, useParams } from "react-router-dom";
import { get_service_by_id, jobPostAsync } from "../../services/services";
import {
  createCustomerWithCardAsync,
  saveCardAsync,
  subscriptionAsync,
} from "../../services/SubscriptionService";
import {
  setBackStepFirst,
  setJobsSteps,
} from "../../store/slices/ui_control_slice";
import { asyncStatus } from "../../utils/asyncStatus";
import {
  setJobPostStatus,
  setJobsImages,
} from "../../store/slices/services_slice";
import {
  service_booking,
  service_booking_keys,
  SERVICE_DETAIL_PAGE_CONSTANT,
  steps_constants,
} from "../../store/constants";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "../../index.css";
import CustomModal from "../common/CustomModal/CustomModal";
import Input from "../common/Input";
import IconInput from "../IconInput/IconInput";
import CustomLocationSearch from "../IconInput/customInput";
import { formatDate, inputDateFormate } from "../../utils/CustomFormator";
import { BiSolidLock } from "react-icons/bi";
import secure_check from "../../assets/secure_check.webp";
import { FiInfo } from "react-icons/fi";
import {
  error_toast_message,
  success_toast_message,
} from "../../utils/toast_message";
import { format } from "date-fns";
import ButtonComp from "../common/ButtonComp";
import { MdOutlineWatchLater } from "react-icons/md";
import { common_caption_strings } from "../../utils/language_controls/constant_strings";
import { apiHandle } from "../../config/apiHandle/apiHandle";
import { setCreateCustomerWithCardStatus } from "../../store/slices/subscription_slice";
import { fetchUserDataAsync } from "../../store/slices/userAuth"; // Import the action
import { getCreditBalance, deductCredits } from "../../utils/creditSystem";

const LastStep = () => {
  const { id } = useParams();
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [checkingSubscription, setCheckingSubscription] = useState(false);
  const [needsSubscription, setNeedsSubscription] = useState(false);
  const [needsCard, setNeedsCard] = useState(false);

  // Payment States
  const [showPaymentForm, setShowPaymentForm] = useState(true);
  const [savedPaymentMethodId, setSavedPaymentMethodId] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [cardError, setCardError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  // Coupon States
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState("");

  // Credit States
  const [availableCredits] = useState(getCreditBalance);
  const [useCredits, setUseCredits] = useState(false);

  // Redux state from subscription slice
  const {
    create_customer_with_card_status,
    create_customer_with_card_data,
    save_card_status,
    subscription_status,
    subscription_data,
    subscription_error,
  } = useSelector((state) => state.subscriptionSlice);

  // Redux state from service slice
  const {
    post_job_service_status,
    post_job_service_data,
    post_job_service_error,
    get_service_by_id_status,
    get_service_by_id_data,
    jobs_images,
  } = useSelector((state) => state.serviceManage);

  const [showGuest, setShowGuest] = useState(false);
  const { user, userAuth, fetch_user_status } = useSelector(
    (state) => state.userAuth
  );

  // Get client secret from Redux state
  const clientSecret = create_customer_with_card_data?.client_secret;

  const jobPostLoader = post_job_service_status === asyncStatus.LOADING;
  const checkingCard = create_customer_with_card_status === asyncStatus.LOADING;
  const subscribingUser = subscription_status === asyncStatus.LOADING;

  const date = JSON.parse(localStorage.getItem(service_booking_keys.DATE));
  const time = localStorage.getItem(service_booking_keys.TIME);
  const desc = localStorage.getItem(service_booking_keys.DESCRIPTION);
  const location = localStorage.getItem(service_booking_keys.LOCATION);
  const price = localStorage.getItem(service_booking_keys.PRICE);
  const images = JSON.parse(localStorage.getItem(service_booking_keys.IMAGES));

  useEffect(() => {
    window.scrollTo(0, 0);

    // Automatically request client secret for card form if user doesn't have a saved card
    if (userAuth && !user?.stripe_payment_method_id) {
      dispatch(createCustomerWithCardAsync());
    }
  }, []);

  // Fetch latest user data on component mount
  useEffect(() => {
    if (userAuth) {
      console.log("Fetching latest user data on mount...");
      dispatch(fetchUserDataAsync());
    }
  }, [userAuth, dispatch]);

  // Check subscription status when user data is loaded
  useEffect(() => {
    if (user && fetch_user_status === asyncStatus.SUCCEEDED) {
      const hasActiveSubscription = checkUserHasActiveSubscription();
      const hasSavedCard = checkUserCard();

      console.log("User loaded - Has active subscription:", hasActiveSubscription);
      console.log("User loaded - Has saved card:", hasSavedCard);

      // Determine what user needs
      if (userChoseSubscription() && !hasActiveSubscription) {
        setNeedsSubscription(true);
        if (!hasSavedCard) {
          setNeedsCard(true);
          // Automatically show payment form when card is needed
          dispatch(createCustomerWithCardAsync());
        } else {
          setNeedsCard(false);
        }
      } else if (!hasSavedCard) {
        setNeedsSubscription(false);
        setNeedsCard(true);
        // Automatically show payment form when card is needed
        dispatch(createCustomerWithCardAsync());
      } else {
        setNeedsSubscription(false);
        setNeedsCard(false);
      }
    }
  }, [user, fetch_user_status, price]);

  useEffect(() => {
    if (post_job_service_status === asyncStatus.SUCCEEDED) {
      navigate("/dashboard/myjobs-user");
      dispatch(setJobsSteps({ value: null }));
      localStorage.removeItem(steps_constants.JOBS_STEP);
      dispatch(setJobsImages([]));
      localStorage.removeItem(service_booking_keys.DATE);
      localStorage.removeItem(service_booking_keys.TIME);
      localStorage.removeItem(service_booking_keys.DESCRIPTION);
      localStorage.removeItem(service_booking_keys.LOCATION);
      localStorage.removeItem(service_booking_keys.PRICE);
      localStorage.removeItem(service_booking_keys.IMAGES);
      dispatch(setJobPostStatus());
    }
  }, [post_job_service_status, navigate]);

  // Handle create customer with card success
  useEffect(() => {
    console.log("Create customer status:", create_customer_with_card_status);
    console.log("Create customer data:", create_customer_with_card_data);

    if (create_customer_with_card_status === asyncStatus.SUCCEEDED) {
      if (create_customer_with_card_data?.client_secret) {
        console.log(
          "Client secret received, showing payment form:",
          create_customer_with_card_data.client_secret
        );
        setShowPaymentForm(true);
      } else {
        console.error("No client secret received");
        setShowPaymentForm(false);
        error_toast_message(
          "Failed to initialize payment setup. Please try again."
        );
      }
      // Reset status to IDLE after handling success
      dispatch(setCreateCustomerWithCardStatus());
    } else if (create_customer_with_card_status === asyncStatus.FAILED) {
      console.error("Failed to create customer with card");
      setShowPaymentForm(false);
      error_toast_message("Failed to setup payment. Please try again.");
      // Reset status to IDLE after handling failure
      dispatch(setCreateCustomerWithCardStatus());
    }
  }, [create_customer_with_card_status, create_customer_with_card_data]);

  // Handle successful card save
  useEffect(() => {
    if (save_card_status === asyncStatus.SUCCEEDED) {
      console.log("Card saved successfully, refreshing user data...");
      
      // Refresh user data to get updated payment method
      dispatch(fetchUserDataAsync());
    }
  }, [save_card_status]);

  // Handle subscription status changes
  useEffect(() => {
    console.log("Subscription status:", subscription_status);
    console.log("Subscription data:", subscription_data);

    if (subscription_status === asyncStatus.SUCCEEDED) {
      console.log("Subscription successful, refreshing user data...");
      success_toast_message("Subscription activated successfully!");

      // Refresh user data to get updated subscription status
      dispatch(fetchUserDataAsync()).then(() => {
        // After refresh, proceed with booking
        const paymentMethodId = user?.stripe_payment_method_id || savedPaymentMethodId;
        if (paymentMethodId) {
          console.log("Proceeding with booking after subscription");
          proceedWithBooking(paymentMethodId);
        }
      });
    } else if (subscription_status === asyncStatus.FAILED) {
      console.error("Subscription failed:", subscription_error);
      error_toast_message(
        subscription_error?.message || "Subscription failed. Please try again."
      );
    }
  }, [subscription_status, subscription_data, subscription_error]);

  // Coupon Functions
  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError("Please enter a coupon code");
      return;
    }

    setCouponLoading(true);
    setCouponError("");

    try {
      const response = await apiHandle.post("/verify-coupon", {
        name: couponCode.trim(),
      });

      console.log("Coupon verification response:", response.data);

      if (response.data.status) {
        const couponData = response?.data.coupon;

        // Handle both percentage and fixed amount coupons based on new backend format
        let discountDisplay = "";
        if (couponData.type === 1 && couponData.percentage !== null) {
          // Percentage discount
          discountDisplay = `${couponData.percentage}% discount`;
        } else if (couponData.type === 0 && couponData.fixedAmount !== null) {
          // Fixed amount discount
          discountDisplay = `$${couponData.fixedAmount} discount`;
        }

        setAppliedCoupon(couponData);
        success_toast_message(`Coupon applied! ${discountDisplay}`);
        setCouponCode("");
      } else {
        setCouponError(response.data.message || "Invalid coupon code");
      }
    } catch (error) {
      console.error("Coupon verification error:", error);
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to verify coupon. Please try again.";
      setCouponError(errorMessage);
    } finally {
      setCouponLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode("");
    setCouponError("");
    success_toast_message("Coupon removed");
  };

  // Helper to check if user has active subscription from latest data
  const checkUserHasActiveSubscription = () => {
    if (!user) return false;

    // Check using the 'type' column - Member means active subscription
    const hasActiveSubscription = user.type === 'Member';

    console.log("Subscription check:", {
      type: user.type,
      subscription_id: user.subscription_id,
      hasActiveSubscription
    });

    return hasActiveSubscription;
  };

  // Helper to determine if user chose subscription pricing
  const userChoseSubscription = () => {
    console.log("Checking if user chose subscription, price:", price);

    // Check if price indicates membership/subscription
    const subscriptionIndicators = ["member", "subscription", "doneplus", "done+", "premium"];
    const isSubscription = subscriptionIndicators.some(indicator =>
      price?.toLowerCase?.()?.includes(indicator)
    );

    console.log("User chose subscription:", isSubscription);
    return isSubscription;
  };

  // Check if user has saved card
  const checkUserCard = () => {
    if (user?.stripe_payment_method_id) {
      console.log("User has saved payment method:", user.stripe_payment_method_id);
      setSavedPaymentMethodId(user.stripe_payment_method_id);
      return true;
    }
    return false;
  };

  const handleConfirmPayment = async () => {
  if (!stripe || !elements || paymentProcessing) return;

  setPaymentProcessing(true);
  setCardError(null);

  try {
    const cardElement = elements.getElement(CardNumberElement);

    if (!cardElement) {
      throw new Error("Card element not found");
    }

    const { error, setupIntent } = await stripe.confirmCardSetup(
      clientSecret,
      {
        payment_method: {
          card: cardElement,
        },
      }
    );

    if (error) {
      console.error("Setup intent error:", error);
      setCardError(error.message);
      setPaymentProcessing(false);
      return;
    }

    if (setupIntent && setupIntent.status === "succeeded") {
      console.log("Setup intent succeeded:", setupIntent);
      const paymentMethodId = setupIntent.payment_method;

      // Save the payment method to user account
      try {
        const saveCardResponse = await dispatch(
          saveCardAsync({ payment_method_id: paymentMethodId })
        ).unwrap();
        console.log("Card saved successfully:", saveCardResponse);
        
        // Set the saved payment method ID
        setSavedPaymentMethodId(paymentMethodId);
        setShowPaymentForm(false);
        success_toast_message("Payment method saved successfully!");

        // Refresh user data to get updated payment method
        await dispatch(fetchUserDataAsync()).unwrap();

        // NOW check if user needs subscription
        const choseSubscription = userChoseSubscription();
        const hasSubscription = checkUserHasActiveSubscription();

        console.log("After card save - Chose subscription:", choseSubscription);
        console.log("After card save - Has subscription:", hasSubscription);

        if (choseSubscription && !hasSubscription) {
          console.log("Card saved successfully, NOW subscribing user...");
          
          // Wait a moment to ensure backend has updated
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          try {
            await dispatch(subscriptionAsync()).unwrap();
            console.log("Subscription successful after card save");
            // Subscription success will be handled by the useEffect
          } catch (subError) {
            console.error("Subscription failed after card save:", subError);
            error_toast_message("Failed to activate subscription. Please try again.");
            setPaymentProcessing(false);
          }
        } else {
          // No subscription needed, proceed with booking directly
          console.log("Card saved, proceeding with booking (no subscription needed)");
          proceedWithBooking(paymentMethodId);
        }
      } catch (saveError) {
        console.error("Failed to save card:", saveError);
        error_toast_message("Failed to save payment method. Please try again.");
        setPaymentProcessing(false);
      }
    }
  } catch (error) {
    console.error("Payment confirmation error:", error);
    setCardError(error.message || "Payment setup failed");
    setPaymentProcessing(false);
  }
};

  const _handleCancelJob = () => {
    dispatch(setJobsSteps({ value: null }));
    localStorage.removeItem(steps_constants.JOBS_STEP);
    localStorage.removeItem(service_booking_keys.DATE);
    localStorage.removeItem(service_booking_keys.TIME);
    localStorage.removeItem(service_booking_keys.DESCRIPTION);
    localStorage.removeItem(service_booking_keys.LOCATION);
    localStorage.removeItem(service_booking_keys.PRICE);
    localStorage.removeItem(service_booking_keys.IMAGES);
  };

  const proceedWithBooking = (paymentMethodId = null) => {
    const jobPostObj = {
      [service_booking_keys.LOCATION]: location,
      [service_booking_keys.SERVICE]: id,
      [service_booking_keys.DESCRIPTION]: desc,
      [service_booking_keys.PRICE]: price,
      [service_booking_keys.IMAGES]: images,
      [service_booking_keys.DATE]: date,
      [service_booking_keys.TIME]: time,
      // Add payment method if available
      ...(paymentMethodId && { payment_method_id: paymentMethodId }),
      // Add coupon if applied - updated for new backend format
      ...(appliedCoupon && {
        coupon_name: appliedCoupon.name,
        coupon_type: appliedCoupon.type, // 0 = fixed amount, 1 = percentage
        coupon_value:
          appliedCoupon.type === 1
            ? appliedCoupon.percentage
            : appliedCoupon.fixedAmount,
      }),
    };

    // Deduct credits if used
    if (useCredits && prices.creditDiscount > 0) {
      deductCredits(prices.creditDiscount);
    }

    console.log("Booking data:", jobPostObj);
    dispatch(jobPostAsync(jobPostObj));
  };

  // Main payment handler
 // Main payment handler
const handlePaymentSubmit = async (event) => {
  event.preventDefault();

  if (checkingCard || jobPostLoader || subscribingUser || checkingSubscription) {
    console.log("Already processing, skipping...");
    return;
  }

  console.log("=== Payment Submit Started ===");
  
  // Refresh user data first to get latest subscription status
  setCheckingSubscription(true);
  try {
    await dispatch(fetchUserDataAsync()).unwrap();
  } catch (error) {
    console.error("Failed to fetch user data:", error);
    error_toast_message("Failed to verify subscription status. Please try again.");
    setCheckingSubscription(false);
    return;
  }
  setCheckingSubscription(false);

  // After refresh, check what user needs
  const hasActiveSubscription = checkUserHasActiveSubscription();
  const hasSavedCard = user?.stripe_payment_method_id ? true : false;
  const choseSubscription = userChoseSubscription();

  console.log("After refresh - Has subscription:", hasActiveSubscription);
  console.log("After refresh - Has card:", hasSavedCard);
  console.log("After refresh - Chose subscription:", choseSubscription);

  // CASE 1: User chose subscription pricing but doesn't have active subscription
  if (choseSubscription && !hasActiveSubscription) {
    console.log("Case 1: User needs subscription");

    // IMPORTANT: Check if user has saved card FIRST
    if (!hasSavedCard) {
      console.log("No saved card - MUST add card BEFORE subscription");
      // Show payment form to collect card details
      dispatch(createCustomerWithCardAsync());
      return; // STOP HERE - don't try to subscribe yet
    }

    // User has card, NOW proceed with subscription
    console.log("Has saved card, creating subscription...");
    try {
      await dispatch(subscriptionAsync()).unwrap();
      console.log("Subscription created successfully");
      // Success handling will be done in useEffect
    } catch (err) {
      console.error("Subscription failed:", err);
      error_toast_message(err?.message || "Subscription failed. Please try again.");
    }
    return;
  }

  // CASE 2: User has subscription (or didn't choose subscription) - just need to ensure card exists
  if (hasSavedCard) {
    console.log("Case 2: Has card, proceeding with booking");
    proceedWithBooking(user.stripe_payment_method_id);
  } else {
    console.log("Case 2: No card, showing payment form");
    dispatch(createCustomerWithCardAsync());
  }
};

  const handleEdit = () => {
    dispatch(setJobsSteps({ value: "2" }));
  };

  function _addThirteenPercent(value) {
    const percentage = value * 0.13;
    const total = value + percentage;
    return total;
  }

  // Calculate prices with coupon discount
  // Calculate prices with coupon discount
const calculatePrices = () => {
  const servicePrice = +get_service_by_id_data?.service?.price;
  let basePrice = servicePrice;

  const isMemberOrWillBe = user?.type === 'Member' || price !== "user";
  if (isMemberOrWillBe) {
    basePrice = servicePrice - 25;
  }

  let couponDiscount = 0;
  if (appliedCoupon) {
    if (appliedCoupon.type === 1 && appliedCoupon.percentage !== null) {
      couponDiscount = (basePrice * appliedCoupon.percentage) / 100;
    } else if (appliedCoupon.type === 0 && appliedCoupon.fixedAmount !== null) {
      couponDiscount = Math.min(appliedCoupon.fixedAmount, basePrice);
    }
    basePrice = basePrice - couponDiscount;
  }

  // Apply credit discount
  const creditDiscount = useCredits ? Math.min(availableCredits, basePrice) : 0;
  basePrice = basePrice - creditDiscount;

  const hst = basePrice * 0.13;
  const totalPrice = basePrice + hst;

  return {
    originalPrice: servicePrice,
    donePlusDiscount: isMemberOrWillBe ? 25 : 0,
    couponDiscount,
    creditDiscount,
    basePrice,
    hst,
    totalPrice,
  };
};

  const prices = calculatePrices();

  return (
    <div>
      <Stack sx={{ px: { xs: 2.5, sm: 4 }, pt: { xs: 2.5, sm: 4 } }}>
        <Stack className="service-name">
          {get_service_by_id_data?.service?.name}
        </Stack>

        <Stack
          className="overflow_stepper"
          sx={{
            overflow: "auto",
          }}
        >
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            className="stepperClass"
            sx={{
              minWidth: "260px",
            }}
          >
            <Stepper
              color={themeOrange}
              fontSize="12px"
              fontColor="black"
              steps={[
                { label: "SCHEDULE" },
                { label: "JOB DETAILS" },
                { label: "CONFIRM" },
              ]}
              currentStep={3}
            />
          </Stack>
        </Stack>
        <Divider sx={{ marginTop: "50px" }} />

        {!userAuth ? (
          <Stack>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={2}
            >
              <ButtonComp
                onClick={() => {
                  navigate("/signup-user");
                  localStorage.setItem(
                    SERVICE_DETAIL_PAGE_CONSTANT.from,
                    "FROM_SERVICE_DETAIL"
                  );
                  localStorage.setItem(
                    SERVICE_DETAIL_PAGE_CONSTANT.service_id,
                    id
                  );
                }}
                label={common_caption_strings.Signup}
                style={{
                  width: "50%",
                  borderRadius: "15px",
                  background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                  margin: "20px 0px",
                }}
              />
              <ButtonComp
                onClick={() => {
                  navigate("/login", { state: { user_role: 3 } });
                  localStorage.setItem(
                    SERVICE_DETAIL_PAGE_CONSTANT.from,
                    "FROM_SERVICE_DETAIL"
                  );
                  localStorage.setItem(
                    SERVICE_DETAIL_PAGE_CONSTANT.service_id,
                    id
                  );
                }}
                label={common_caption_strings.Login}
                style={{
                  width: "50%",
                  borderRadius: "15px",
                  background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                  margin: "20px 0px",
                }}
              />
            </Stack>
            {/* Or book without creating an account first (an account is still
                made in the background — see GuestCheckout). */}
            {!showGuest ? (
              <Typography
                onClick={() => setShowGuest(true)}
                sx={{ textAlign: "center", fontSize: "15px", fontWeight: 600, color: "#C53F10", cursor: "pointer", textDecoration: "underline", mt: 0.5 }}
              >
                Continue as guest
              </Typography>
            ) : (
              <GuestCheckout />
            )}
          </Stack>
        ) : (
          <Stack>
            <Stack mt={4}>
              <Stack flexDirection={"row"} alignItems={"center"} gap={"9px"}>
                <Stack>
                  <img
                    width={"40px"}
                    height={"40px"}
                    src={serName}
                    alt="Service Name"
                  />
                </Stack>
                <Typography className="Service-Name-head">
                  {get_service_by_id_data?.service?.name}
                </Typography>
              </Stack>
              {date?.length > 0 && (
                <Stack ml={1}>
                  {date?.map(({ selected_date, shifts }) => {
                    return (
                      <Stack
                        key={selected_date}
                        mt={2}
                        flexDirection={"row"}
                        alignItems={"center"}
                        gap={2}
                      >
                        <Stack>
                          <LuCalendarClock
                            style={{
                              color: themeOrange,
                              fontSize: "26px",
                              flexShrink: "0",
                            }}
                          />
                        </Stack>
                        <Typography className="Service-Name-list">
                          {(() => {
                            const [year, month, day] = selected_date.split("-");
                            const localDate = new Date(year, month - 1, day);
                            return format(localDate, "EEE, MMM d, yyyy");
                          })()}
                        </Typography>
                        <Typography className="service_shifts_txt">
                          (
                          {shifts?.map((shift) => shift.slice(0, 3)).join(", ")}
                          )
                        </Typography>
                      </Stack>
                    );
                  })}
                </Stack>
              )}
              {location && (
                <Stack
                  mt={2}
                  ml={1}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={2}
                >
                  <Stack>
                    <FaLocationDot color={themeOrange} size={26} />
                  </Stack>
                  <Typography className="Service-Name-list">
                    {location === "undefined" ? "" : location}
                  </Typography>
                </Stack>
              )}
              {desc && (
                <Stack
                  mt={2}
                  ml={1}
                  flexDirection={"row"}
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  gap={2}
                >
                  <Stack>
                    <IoDocumentTextSharp color={themeOrange} size={26} />
                  </Stack>
                  <Typography className="Service-Name-list">
                    {desc || ""}
                  </Typography>
                </Stack>
              )}
              {time && (
                <Stack
                  mt={2}
                  ml={1}
                  flexDirection={"row"}
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  gap={2}
                >
                  <Stack>
                    <MdOutlineWatchLater color={themeOrange} size={26} />
                  </Stack>
                  <Typography className="Service-Name-list">
                    {time || ""}
                  </Typography>
                </Stack>
              )}
            </Stack>

            {/* Show subscription notice if needed */}
            {needsSubscription && (
              <Stack
                mb={2}
                mt={3}
                p={2}
                sx={{
                  backgroundColor: '#fff3e0',
                  borderRadius: '8px',
                  border: '1px solid #ffb74d'
                }}
              >
                <Typography variant="body2" color="#e65100" fontWeight="600">
                  ⭐ Done+ Membership Required
                </Typography>
                <Typography variant="caption" color="#e65100">
                  This service requires a Done+ membership for the $25 discount.
                  {needsCard 
                    ? " Please add a payment method to subscribe and book." 
                    : " Click 'Subscribe & Book' to activate your membership."}
                </Typography>
              </Stack>
            )}


            {/* Show card notice if needed */}
            {needsCard && !needsSubscription && (
              <Stack
                mb={2}
                mt={3}
                p={2}
                sx={{
                  backgroundColor: '#e3f2fd',
                  borderRadius: '8px',
                  border: '1px solid #2196f3'
                }}
              >
                <Typography variant="body2" color="#1976d2" fontWeight="600">
                  💳 Payment Method Required
                </Typography>
                <Typography variant="caption" color="#1976d2">
                  Please add a payment method to complete your booking.
                </Typography>
              </Stack>
            )}

            {/* Coupon Section */}
            <Divider sx={{ marginTop: "30px" }} />
            <Stack my={3}>
              <Typography className="heading-name-text">Promo Code</Typography>

              {!appliedCoupon ? (
                <Stack mt={2} spacing={2}>
                  <TextField
                    fullWidth
                    placeholder="Enter coupon code"
                    value={couponCode}
                    onChange={(e) => {
                      setCouponCode(e.target.value.toUpperCase());
                      if (couponError) setCouponError("");
                    }}
                    error={!!couponError}
                    helperText={couponError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MdLocalOffer color={themeOrange} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            onClick={handleApplyCoupon}
                            disabled={couponLoading || !couponCode.trim()}
                            sx={{
                              minWidth: "auto",
                              padding: "4px 12px",
                              fontSize: "12px",
                              background:
                                "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                              color: "white",
                              "&:hover": {
                                background:
                                  "linear-gradient(180deg, #E54920 0%, #B8390E 100%)",
                              },
                              "&:disabled": {
                                background: "#ccc",
                                color: "#999",
                              },
                            }}
                          >
                            {couponLoading ? (
                              <CircularProgress
                                size={12}
                                sx={{ color: "white" }}
                              />
                            ) : (
                              "Apply"
                            )}
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Stack>
              ) : (
                <Stack mt={2}>
                  <Alert
                    severity="success"
                    action={
                      <Button
                        color="inherit"
                        size="small"
                        onClick={handleRemoveCoupon}
                        sx={{ fontWeight: "bold" }}
                      >
                        Remove
                      </Button>
                    }
                  >
                    <Stack>
                      <Typography variant="body2" fontWeight="600">
                        Coupon Applied: {appliedCoupon.name}
                      </Typography>
                      <Typography variant="caption">
                        {appliedCoupon.type === 1
                          ? `${appliedCoupon.percentage}% discount on service amount`
                          : `$${appliedCoupon.fixedAmount} discount on service amount`}
                      </Typography>
                    </Stack>
                  </Alert>
                </Stack>
              )}
            </Stack>

            {/* Done Protection Guarantee */}
            <Stack
              direction="row"
              alignItems="flex-start"
              gap={1.5}
              mt={3}
              p={2}
              sx={{
                backgroundColor: "#f8faf8",
                borderRadius: "8px",
                border: "1px solid #e8f0e8",
              }}
            >
              <MdVerifiedUser
                size={36}
                color="#22c55e"
                style={{ flexShrink: 0 }}
              />
              <Stack>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    mb: 0.5
                  }}
                >
                  Done Protection Guarantee
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.5
                  }}
                >
                  Every booking is protected. If you're not satisfied, we'll make it right or refund your money.
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.5,
                    mt: 1.5
                  }}
                >
                  <strong style={{ color: "#1a1a1a" }}>Free cancellation.</strong> Cancel at no cost anytime before your professional begins traveling to you.
                </Typography>
              </Stack>
            </Stack>

            {/* How much will my job cost? */}
            <Stack
              direction="row"
              alignItems="flex-start"
              gap={1.5}
              mt={2}
              p={2}
              sx={{
                backgroundColor: `${themeOrange}08`,
                borderRadius: "8px",
                border: `1px solid ${themeOrange}30`,
              }}
            >
              <FiInfo
                size={20}
                color={themeOrange}
                style={{ flexShrink: 0, marginTop: "2px" }}
              />
              <Stack>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    mb: 0.5,
                  }}
                >
                  How much will my job cost?
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.6,
                  }}
                >
                  Once you're matched with a Pro, you can chat with them directly in the app to discuss the scope of work and get a clearer picture of the final cost before anything gets started.
                </Typography>
              </Stack>
            </Stack>

            <Divider sx={{ marginTop: "24px" }} />
            <Stack my={3}>
              <Typography className="heading-name-text">
                Service Rate
              </Typography>
            </Stack>
            <Divider sx={{ marginTop: "20px" }} />

            {/* Service Amount */}
            <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
              <Stack flex={1} className="service-list">
                <Typography
                  sx={{ textTransform: "capitalize", fontWeight: "500" }}
                >
                  Service Amount
                </Typography>
              </Stack>
              <Typography
                className="service-list number_family"
                sx={{
                  fontSize: "20px",
                  fontWeight: "700 !important",
                  color: `${themeOrange} !important`,
                }}
              >
                ${prices.originalPrice.toLocaleString()}
              </Typography>
            </Stack>

            {/* Done+ Member Discount */}
            {price !== "user" && (
              <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flex={1}
                  className="service-list"
                  gap={2}
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: "500",
                      color: themeBlue,
                    }}
                  >
                    Done+ Member Discount{" "}
                  </Typography>
                  <Tooltip
                    title="Done+ Members get $25 off on every job."
                    placement="top"
                  >
                    <IconButton>
                      <FiInfo style={{ fontSize: "20px", color: "grey" }} />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Typography
                  className="service-list number_family"
                  sx={{
                    fontSize: "20px",
                    fontWeight: "700 !important",
                    color: `${themeBlue} !important`,
                  }}
                >
                  - ${prices.donePlusDiscount}
                </Typography>
              </Stack>
            )}

            {/* Coupon Discount */}
            {appliedCoupon && (
              <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flex={1}
                  className="service-list"
                  gap={2}
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: "500",
                      color: "#4caf50",
                    }}
                  >
                    Coupon Discount (
                    {appliedCoupon.type === 1
                      ? `${appliedCoupon.percentage}%`
                      : `$${appliedCoupon.fixedAmount}`}
                    )
                  </Typography>
                </Stack>
                <Typography
                  className="service-list number_family"
                  sx={{
                    fontSize: "20px",
                    fontWeight: "700 !important",
                    color: "#4caf50 !important",
                  }}
                >
                  - ${prices.couponDiscount.toFixed(2)}
                </Typography>
              </Stack>
            )}

            {/* Credits Toggle */}
            {availableCredits > 0 && (
              <Stack
                mt={1}
                p={1.5}
                sx={{
                  backgroundColor: useCredits ? "#fff3e0" : "#fafafa",
                  borderRadius: "8px",
                  border: `1px solid ${useCredits ? "#ffb74d" : "#e0e0e0"}`,
                  cursor: "pointer",
                }}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setUseCredits((v) => !v)}
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <Checkbox
                    checked={useCredits}
                    onChange={() => setUseCredits((v) => !v)}
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                      padding: "2px",
                      color: "#ffb74d",
                      "&.Mui-checked": { color: "#e65100" },
                    }}
                    size="small"
                  />
                  <Stack>
                    <Typography sx={{ fontWeight: "600", fontSize: "14px", color: "#e65100" }}>
                      💳 Use my credits
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#888" }}>
                      ${availableCredits.toFixed(2)} available
                    </Typography>
                  </Stack>
                </Stack>
                {useCredits && (
                  <Typography sx={{ fontWeight: "700", fontSize: "16px", color: "#e65100" }}>
                    - ${Math.min(availableCredits, prices.basePrice + prices.creditDiscount).toFixed(2)}
                  </Typography>
                )}
              </Stack>
            )}

            {/* Credit Discount line */}
            {useCredits && prices.creditDiscount > 0 && (
              <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
                <Stack flex={1} className="service-list">
                  <Typography sx={{ textTransform: "capitalize", fontWeight: "500", color: "#e65100" }}>
                    Credits Applied
                  </Typography>
                </Stack>
                <Typography
                  className="service-list number_family"
                  sx={{ fontSize: "20px", fontWeight: "700 !important", color: "#e65100 !important" }}
                >
                  - ${prices.creditDiscount.toFixed(2)}
                </Typography>
              </Stack>
            )}

            {/* HST */}
            <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
              <Stack flex={1} className="service-list">
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    color: themeBlue,
                  }}
                >
                  HST (13%)
                </Typography>
              </Stack>
              <Typography
                className="service-list number_family"
                sx={{
                  fontSize: "20px",
                  fontWeight: "700 !important",
                  color: `${themeBlue} !important`,
                }}
              >
                ${prices.hst.toFixed(2)}
              </Typography>
            </Stack>

            {/* Total Price */}
            <Stack mt={0.5} flexDirection={"row"} alignItems={"center"}>
              <Stack flex={1} className="service-list">
                <Typography
                  sx={{ textTransform: "capitalize", fontWeight: "500" }}
                >
                  Total Price
                </Typography>
              </Stack>
              <Typography
                className="service-list number_family"
                sx={{
                  fontSize: "20px",
                  fontWeight: "700 !important",
                  color: `${themeOrange} !important`,
                }}
              >
                ${prices.totalPrice.toFixed(2)}
              </Typography>
            </Stack>

            {/* Savings Summary */}
            {(appliedCoupon || price !== "user") && (
              <Stack
                mt={2}
                p={2}
                sx={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
              >
                <Typography
                  variant="body2"
                  color="success.main"
                  fontWeight="600"
                >
                  🎉 You're saving $
                  {(prices.donePlusDiscount + prices.couponDiscount).toFixed(2)}{" "}
                  on this booking!
                </Typography>
              </Stack>
            )}

            <Divider sx={{ marginTop: "15px" }} />

            {/* Payment Form Section - Jiffy Style */}
            {(showPaymentForm || needsCard) && clientSecret && (
              <Stack mt={3} mb={3}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    {user?.stripe_payment_method_id ? "Add new card" : "Payment method"}
                  </Typography>
                  {user?.stripe_payment_method_id && (
                    <Button
                      variant="text"
                      onClick={() => setShowPaymentForm(false)}
                      sx={{
                        fontSize: "13px",
                        color: "#666",
                        textTransform: "none",
                        fontWeight: "500",
                        padding: "4px 8px",
                        minWidth: "auto",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                </Stack>

                <Stack
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  {/* Card Number Field */}
                  <Box
                    sx={{
                      padding: "16px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <Stack direction="row" alignItems="center" gap={0.5} mb={1}>
                      <MdLock size={12} color="#666" />
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500"
                        }}
                      >
                        Card number
                      </Typography>
                    </Stack>
                    <CardNumberElement
                      options={{
                        style: {
                          base: {
                            fontSize: "16px",
                            color: "#1a1a1a",
                            fontFamily: '"Poppins", -apple-system, sans-serif',
                            fontSmoothing: "antialiased",
                            "::placeholder": {
                              color: "#999",
                            },
                          },
                          invalid: {
                            color: "#dc3545",
                          },
                        },
                        placeholder: "1234 1234 1234 1234",
                      }}
                      onChange={(event) => {
                        if (event.error) {
                          setCardError(event.error.message);
                        } else if (!event.complete) {
                          setCardError(null);
                        }
                      }}
                    />
                  </Box>

                  {/* Expiry and CVC Row */}
                  <Stack direction="row">
                    <Box
                      sx={{
                        flex: 1,
                        padding: "16px",
                        borderRight: "1px solid #e0e0e0",
                      }}
                    >
                      <Stack direction="row" alignItems="center" gap={0.5} mb={1}>
                        <MdLock size={12} color="#666" />
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "500"
                          }}
                        >
                          Expiry date
                        </Typography>
                      </Stack>
                      <CardExpiryElement
                        options={{
                          style: {
                            base: {
                              fontSize: "16px",
                              color: "#1a1a1a",
                              fontFamily: '"Poppins", -apple-system, sans-serif',
                              fontSmoothing: "antialiased",
                              "::placeholder": {
                                color: "#999",
                              },
                            },
                            invalid: {
                              color: "#dc3545",
                            },
                          },
                          placeholder: "MM / YY",
                        }}
                        onChange={(event) => {
                          if (event.error) {
                            setCardError(event.error.message);
                          } else if (!event.complete) {
                            setCardError(null);
                          }
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        flex: 1,
                        padding: "16px",
                      }}
                    >
                      <Stack direction="row" alignItems="center" gap={0.5} mb={1}>
                        <MdLock size={12} color="#666" />
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "500"
                          }}
                        >
                          Security code
                        </Typography>
                      </Stack>
                      <CardCvcElement
                        options={{
                          style: {
                            base: {
                              fontSize: "16px",
                              color: "#1a1a1a",
                              fontFamily: '"Poppins", -apple-system, sans-serif',
                              fontSmoothing: "antialiased",
                              "::placeholder": {
                                color: "#999",
                              },
                            },
                            invalid: {
                              color: "#dc3545",
                            },
                          },
                          placeholder: "CVC",
                        }}
                        onChange={(event) => {
                          if (event.error) {
                            setCardError(event.error.message);
                          } else {
                            setCardError(null);
                          }
                          setPaymentMethod(event.complete ? event : null);
                        }}
                      />
                    </Box>
                  </Stack>
                </Stack>

                {cardError && (
                  <Typography
                    sx={{
                      color: "#dc3545",
                      fontSize: "13px",
                      mt: 1
                    }}
                  >
                    {cardError}
                  </Typography>
                )}

                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#666",
                    mt: 2
                  }}
                >
                  🛡️ You won't be charged until the job is complete
                </Typography>

                {/* Save Card Button */}
                <Button
                  variant="contained"
                  onClick={handleConfirmPayment}
                  disabled={paymentProcessing || !stripe || !elements}
                  fullWidth
                  sx={{
                    mt: 3,
                    backgroundColor: "#F15A24",
                    color: "white",
                    borderRadius: "8px",
                    padding: "14px 24px",
                    textTransform: "none",
                    fontWeight: "600",
                    fontSize: "15px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#d94d1a",
                      boxShadow: "none",
                    },
                    "&:disabled": {
                      backgroundColor: "#ccc",
                      color: "#999",
                    },
                  }}
                >
                  {paymentProcessing ? (
                    <Stack direction="row" alignItems="center" gap={1}>
                      <CircularProgress size={18} sx={{ color: "white" }} />
                      <span>Processing...</span>
                    </Stack>
                  ) : (
                    "Save card"
                  )}
                </Button>

                {/* Powered by Stripe */}
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  gap={0.5}
                  mt={2}
                >
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#999"
                    }}
                  >
                    Powered by
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#635bff",
                      fontWeight: "600"
                    }}
                  >
                    Stripe
                  </Typography>
                </Stack>
              </Stack>
            )}

            {/* Saved Card Info - Show when user has a card */}
            {!needsCard && user?.stripe_payment_method_id && (
              <Stack mt={3}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    Payment method
                  </Typography>
                  <Button
                    variant="text"
                    onClick={() => {
                      dispatch(createCustomerWithCardAsync());
                    }}
                    disabled={checkingCard}
                    sx={{
                      fontSize: "13px",
                      color: themeOrange,
                      textTransform: "none",
                      fontWeight: "500",
                      padding: "4px 8px",
                      minWidth: "auto",
                      "&:hover": {
                        backgroundColor: "rgba(241, 90, 36, 0.08)",
                      },
                    }}
                  >
                    {checkingCard ? "Loading..." : "Change card"}
                  </Button>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{
                    padding: "16px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                  }}
                >
                  <Stack
                    sx={{
                      width: "40px",
                      height: "26px",
                      backgroundColor: "#1a1f71",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2
                    }}
                  >
                    <Typography sx={{ color: "#fff", fontSize: "10px", fontWeight: "700" }}>
                      VISA
                    </Typography>
                  </Stack>
                  <Stack flex={1}>
                    <Typography sx={{ fontSize: "14px", color: "#1a1a1a" }}>
                      •••• •••• •••• {user?.card_last_four || "****"}
                    </Typography>
                  </Stack>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#22c55e",
                      fontWeight: "500"
                    }}
                  >
                    ✓ Saved
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={1} mt={1.5}>
                  <MdLock size={12} color="#999" />
                  <Typography sx={{ fontSize: "11px", color: "#999" }}>
                    You'll only be charged after your service is complete
                  </Typography>
                </Stack>
              </Stack>
            )}

            {/* Loading state while payment form is being prepared */}
            {!showPaymentForm && checkingCard && (
              <Stack mt={3}>
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#1a1a1a",
                    mb: 2
                  }}
                >
                  Payment method
                </Typography>
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    padding: "32px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                  }}
                >
                  <CircularProgress size={24} sx={{ color: "#F15A24", mb: 1.5 }} />
                  <Typography sx={{ fontSize: "13px", color: "#666" }}>
                    Loading payment form...
                  </Typography>
                </Stack>
              </Stack>
            )}

            {/* Confirm Booking Button - Show when user has card and no payment form needed */}
            {!needsCard && user?.stripe_payment_method_id && (
              <Button
                variant="contained"
                onClick={
                  jobPostLoader || subscribingUser || checkingSubscription ? () => {} : handlePaymentSubmit
                }
                disabled={jobPostLoader || subscribingUser || checkingSubscription}
                fullWidth
                sx={{
                  mt: 3,
                  backgroundColor: "#F15A24",
                  color: "white",
                  borderRadius: "8px",
                  padding: "14px 24px",
                  textTransform: "none",
                  fontWeight: "600",
                  fontSize: "15px",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#d94d1a",
                    boxShadow: "none",
                  },
                  "&:disabled": {
                    backgroundColor: "#ccc",
                    color: "#999",
                  },
                }}
              >
                {jobPostLoader || subscribingUser || checkingSubscription ? (
                  <Stack direction="row" alignItems="center" gap={1}>
                    <CircularProgress size={18} sx={{ color: "white" }} />
                    <span>Processing...</span>
                  </Stack>
                ) : needsSubscription ? (
                  "Subscribe & Book"
                ) : (
                  "Confirm booking"
                )}
              </Button>
            )}

            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              mt={3}
              gap={2}
              mb={10}
            >
              <Button
                onClick={handleEdit}
                variant="outlined"
                sx={{
                  flex: 1,
                  color: "#666",
                  borderColor: "#e0e0e0",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: "500",
                  fontSize: "14px",
                  "&:hover": {
                    borderColor: "#ccc",
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                Edit details
              </Button>
              <Button
                onClick={_handleCancelJob}
                variant="text"
                sx={{
                  flex: 1,
                  color: "#999",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: "500",
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "#f9f9f9",
                    color: "#666",
                  },
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Stack>
        )}
      </Stack>
    </div>
  );
};

const WrappedLastStep = () => <LastStep />;

export default WrappedLastStep;